import { createStore } from 'vuex'
import helper from "@/asstes/help.js";
import { Encrypt, Decrypt } from "@/asstes/utils.js";
import md5 from "js-md5";
import axios from "axios";
export default createStore({
  state: {
    classa: 'on',
    classb: '',
    lobg: 'lobg',
    con1: 'con1',
    con2: 'con2',
    section1: 'sectionon',
    section2: 'sectionnone',
    on1: 'on',
    on2: '',
    random: '',
    ul0: 'ul1 cl',
    ula: '',
    lia0: '',
    lia1: '',
    lia2: '',
    lia3: '',
    lia4: '',
    ul2: 'ul1 cl',
    ulb: '',
    lib0: '',
    lib1: '',
    lib2: '',
    lib3: '',
    lib4: '',
    lib5: '',
    lib6: '',
    lib7: '',
    lib8: '',
    ul3: 'ul1 cl',
    ulc: '',
    lic0: '',
    lic1: '',
    lic2: '',
    lic3: '',
    lic4: '',
    tcexit: 'tcexit',
    pan: [],
    index1: 'index1 fl',
    caozuo: 'caozuo',
    paixu: [{
      name: '按名称',
      value: '0',
      select: true
    },
    {
      name: '按日期',
      value: '1',
      select: false
    },
    {
      name: '按类别',
      value: '2',
      select: false
    },
    {
      name: '按大小',
      value: '3',
      select: false
    }],
    strong: 'strong',
    strvalue: '按名称',
    value: '0',
    disklist: [],
    curdiskid: 0,
    Gdisklist: [],
    GGdisklist: [],
    folderlist: [],
    filelist: [],
    imgs: [],
    descs: [],
    itemsx: [
      {
        value: "1",
        name: "加密",
        checked: true,
      },
      {
        value: "2",
        name: "公开",
        checked: false,
      }
    ],
    curpage: 1,
    pagesize: 10,
    totaltiao: 0,
    pages: 0,
    curzhi: 0,
    biaoti: "",
    filelisty: [],
    plist: [],
    upjson: [],
    uj: 0,
    dn: false,
    mulu: [{ "title": "", "link": "" }],
    yema: [],
    cunbchu: [],
    meaagenum: 0,
    daohang: [],
    daohangx: [],
    folderlistlist: [],
    pandui: [],
    filetype: ""
  },
  getters: {
  },
  mutations: {
    setfiletype(state, zhi) {
      state.filetype = zhi
    },
    getpandui(state, jsonx) {
      const timestamp = new Date().getTime();
      const moduleid = "2003";
      const datan = JSON.parse(jsonx);
      const params = {
        "typeid": datan.typeid,
      };
      const jmparams = Encrypt(params);
      const sign = md5(timestamp + moduleid + jmparams);
      axios
        .post(
          helper.webUrl +
          "clientAPI.do?moduleid=" +
          moduleid +
          "&timestamp=" +
          timestamp +
          "&params=" +
          jmparams +
          "&sign=" +
          sign,
          {}
        )
        .then(function (res) {
          if (res.status == 200) {
            const dda = res.data;
            const datas = Decrypt(dda);
            const datan = JSON.parse(datas);
            if (datan.result == "1") {
              state.pandui = datan.data;
            }
          }
        });
    },
    getdaohang(state) {

      const timestampx = new Date().getTime();
      const moduleidx = "0001";
      const paramsx = {};
      const jmparamsx = Encrypt(paramsx);
      const signx = md5(timestampx + moduleidx + jmparamsx);
      axios
        .post(
          helper.webUrl +
          "clientAPI.do?moduleid=" +
          moduleidx +
          "&timestamp=" +
          timestampx +
          "&params=" +
          jmparamsx +
          "&sign=" +
          signx,
          {}
        )
        .then(function (res) {
          //添加浏览者信息
          const ddax = res.data;
          const datasx = Decrypt(ddax);
          const datanx = JSON.parse(datasx);
          if (datanx.result == "1") {
            const zyk = datanx.data.zyk;
            const xc = datanx.data.xc;
            const wk = datanx.data.wk;

            const timestamp = new Date().getTime();
            const moduleid = "1008";
            const username = localStorage.getItem("loginname");
            const password = localStorage.getItem("password");
            const params = {
              "loginname": username,
              "password": Decrypt(password),
            };
            const jmparams = Encrypt(params);
            const sign = md5(timestamp + moduleid + jmparams);
            axios
              .post(
                helper.webUrl +
                "clientAPI.do?moduleid=" +
                moduleid +
                "&timestamp=" +
                timestamp +
                "&params=" +
                jmparams +
                "&sign=" +
                sign,
                {}
              )
              .then(function (res) {
                if (res.status == 200) {
                  const dda = res.data;
                  const datas = Decrypt(dda);
                  const datan = JSON.parse(datas);
                  let z = 0;
                  if (datan.result == "1") {
                    state.daohang = [];
                    state.daohangx = [];
                    for (let i = 0; i < datan.data.length; i++) {
                      const shortname = datan.data[i].shortname;
                      const link = datan.data[i].linkurl;
                      const links = link.split("/");
                      if (links.length == 5) {
                        const zhi = links[4].split(".");
                        const rpt = Encrypt(zhi[0]);
                        datan.data[i].linkurl = "/#/" + links[3] + "?typeid=" + rpt
                      }
                      if ((shortname == "教研") || (shortname == "图库") || (shortname == "微课")) {
                        if ((zyk == '1') && (shortname == "教研")) {
                          state.daohang.push(datan.data[i]);
                          if (z <= 2) {
                            state.daohangx.push(datan.data[i]);
                            z++;
                          }
                        }
                        if ((xc == '1') && (shortname == "图库")) {
                          state.daohang.push(datan.data[i]);
                          if (z <= 2) {
                            state.daohangx.push(datan.data[i]);
                            z++;
                          }
                        }
                        if ((wk == '1') && (shortname == "微课")) {
                          state.daohang.push(datan.data[i]);
                          if (z <= 2) {
                            state.daohangx.push(datan.data[i]);
                            z++;
                          }
                        }
                      }
                      else {
                        state.daohang.push(datan.data[i]);
                        if (z <= 2) {
                          state.daohangx.push(datan.data[i]);
                          z++;
                        }
                      }

                    }
                  }
                }
              });
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    getmessage(state) {
      const timestamp = new Date().getTime();
      const moduleid = "5001";
      const username = localStorage.getItem("loginname");
      const params = {
        "loginname": username
      };
      const jmparams = Encrypt(params);
      const sign = md5(timestamp + moduleid + jmparams);
      axios
        .post(
          helper.webUrl +
          "clientAPI.do?moduleid=" +
          moduleid +
          "&timestamp=" +
          timestamp +
          "&params=" +
          jmparams +
          "&sign=" +
          sign,
          {}
        )
        .then(function (res) {
          if (res.status == 200) {
            const dda = res.data;
            const datas = Decrypt(dda);
            const datan = JSON.parse(datas);
            if (datan.result == "1") {
              state.meaagenum = datan.data;
            }
          }
        });
    },
    setyema(state, cur) {
      state.yema = cur;
    },
    setcurpages(state, curpage) {
      state.curpage = curpage;
    },
    setpages(state, json) {
      state.curpage = 1;
      state.pagesize = json;
    },
    dqmulu(state) {
      state.mulu = JSON.parse(localStorage.getItem("mulu"));
    },
    dhset(state, zhi) {////到第几个
      const mulux = JSON.parse(localStorage.getItem("mulu"));
      state.mulu = mulux.slice(0, zhi + 1);
      localStorage.setItem("mulu", JSON.stringify(state.mulu))
    },
    dhdes(state) {//减少一个
      const mulux = JSON.parse(localStorage.getItem("mulu"));
      if (mulux.length > 1) {
        state.mulu = mulux.slice(0, mulux.length - 1);
      }
      localStorage.setItem("mulu", JSON.stringify(state.mulu))
    },
    yijiset(state, jsonx) {
      const datan = JSON.parse(jsonx);
      state.mulu = [{ "title": datan.title, "link": datan.link }];
      localStorage.setItem("mulu", JSON.stringify(state.mulu))
    },
    erjiset(state, jsonx) {
      const datan = JSON.parse(jsonx);
      state.mulu.push(datan);
      localStorage.setItem("mulu", JSON.stringify(state.mulu))
    },
    upsetjsont(state, j) {
      for (let i = 0; i < state.upjson.length; i++) {
        if (i == j) {
          state.upjson[i].zanting = true;
        }
      }
    },
    upsetjsonf(state, j) {
      for (let i = 0; i < state.upjson.length; i++) {
        if (i == j) {
          state.upjson[i].zanting = false;
        }
      }
    },
    updelejsonf(state, j) {
      for (let i = 0; i < state.upjson.length; i++) {
        if (i == j) {
          state.upjson[i].xianshi = false;
        }
      }
    },
    setnone(state) {
      state.upjson = []
    },
    setupjsonx(state, jsonx) {
      const datan = JSON.parse(jsonx);
      for (let i = 0; i < state.upjson.length; i++) {
        if (state.upjson[i].fileName == datan.fileName) {
          state.upjson[i].perbai = datan.perbai;
        }
      }
    },
    setupjson(state, jsonx) {
      const datan = JSON.parse(jsonx);
      if (state.upjson.length == 0) {
        state.upjson.push(datan);
        state.uj++;
      }
      else {
        let yn = 0;
        for (let i = 0; i < state.upjson.length; i++) {
          if (state.upjson[i].fileName == datan.fileName) {
            state.upjson[i].fileName = datan.fileName;
            state.upjson[i].load = datan.load;
            state.upjson[i].total = datan.total;
            state.upjson[i].pre = datan.pre;
            state.upjson[i].perbai = datan.perbai;
            state.upjson[i].fileEx = datan.fileEx;
            state.upjson[i].speedx = datan.speedx;
            state.upjson[i].zanting = false;
            state.upjson[i].xianshi = true;
            yn = 1;
          }
        }
        if (yn == 0) {
          state.upjson.push(datan);
          state.uj++;
        }
      }
    },
    pagefirst(state) {
      state.curpage = 1;
    },
    pagelast(state) {
      state.curpage = state.pages;
    },
    pageadd(state) {
      if (state.curpage < state.pages) {
        state.curpage++;
      }
    },
    pagesub(state) {
      if (state.curpage > 1) {
        state.curpage--;
      }
    },
    choosey(state) {
      //选择图片类型      
      state.biaoti = "我的回收站";
    },
    choose(state, zhi) {
      state.curpage = 1;
      state.filetype = zhi;
      //选择图片类型
      if (zhi == 0) {
        state.filetype = "";
        state.biaoti = "快速导航";
      }
      if (zhi == 1) {
        state.biaoti = "图片文件";
      }
      if (zhi == 2) {
        state.biaoti = "视频文件";
      }
      if (zhi == 3) {
        state.biaoti = "音频文件";
      }
      if (zhi == 4) {
        state.biaoti = "文档文件";
      }
      if (zhi == 5) {
        state.biaoti = "其他文件";
      }
    },
    pubitemsx(state, jsonx) {
      for (let i = 0; i < state.itemsx.length; i++) {
        state.itemsx[i].checked = false;
      }
      const datan = JSON.parse(jsonx);
      state.itemsx[datan.index].checked = datan.checked;
    },
    setfolderlist(state, jsonx) {
      const datan = JSON.parse(jsonx);
      state.folderlist[datan.index].checked = datan.checked;
    },
    setfilelist(state, jsonx) {
      const datan = JSON.parse(jsonx);
      state.filelist[datan.index].checked = datan.checked;
    },
    setfilelistx(state, jsonx) {
      const datan = JSON.parse(jsonx);
      state.plist[datan.index].checked = datan.checked;
    },
    jieshubianji(state) {
      for (let i = 0; i < state.folderlist.length; i++) {
        state.folderlist[i].bianji = "";
      }
      for (let i = 0; i < state.filelist.length; i++) {
        state.filelist[i].bianji = "";
      }
    },
    setfolderbianjie(state, jsonx) {
      const datan = JSON.parse(jsonx);
      for (let i = 0; i < state.folderlist.length; i++) {
        state.folderlist[i].bianji = "";
      }
      state.folderlist[datan.index].bianji = datan.bianji;
    },
    setfilebianjie(state, jsonx) {
      const datan = JSON.parse(jsonx);
      for (let i = 0; i < state.filelist.length; i++) {
        state.filelist[i].bianji = "";
      }
      state.filelist[datan.index].bianji = datan.bianji;
    },
    setpaixu(state, value) {
      state.value = value
      if (value == 0) {
        state.strvalue = '按名称'
      }
      if (value == 1) {
        state.strvalue = '按日期'
      }
      if (value == 2) {
        state.strvalue = '按类别'
      }
      if (value == 3) {
        state.strvalue = '按大小'
      }
    },
    setstrong(state) {
      if (state.strong == 'strong') {
        state.strong = 'strong on'
      }
      else {
        state.strong = 'strong'
      }
    },
    setzhedie(state) {
      if (state.caozuo == 'caozuo') {
        state.index1 = 'index1 on fl'
        state.caozuo = 'caozuo on'
      }
      else {
        state.index1 = 'index1 fl'
        state.caozuo = 'caozuo'
      }
    },
    setClassa(state, payload) {
      state.classa = payload
      state.classb = ''
      state.con1 = 'con1'
      state.con2 = 'con2'
    },
    random(state, payload) {
      state.random = payload
    },
    setClassb(state, payload) {
      state.classa = ''
      state.classb = payload
      state.con1 = 'con2'
      state.con2 = 'con1'
    },
    xiazai(state) {
      state.lobg = 'lobgx'
    },
    closexiazai(state) {
      state.lobg = 'lobg'
    },
    qihuan(state, n) {
      if (n == 0) {
        state.section1 = 'sectionon'
        state.section2 = 'sectionnone'
        state.on1 = 'on'
        state.on2 = ''
      }
      else {
        state.section1 = 'sectionnone'
        state.section2 = 'sectionon'
        state.on1 = ''
        state.on2 = 'on'
      }
    },
    //修改第一路导航
    setlia(state, zhi) {
      const zhi1 = JSON.parse(zhi);
      state.ula = 'ul1 cl on',
        state.lia0 = '',
        state.lia1 = '',
        state.lia2 = '',
        state.lia3 = '';
      if (zhi1 == 1) {
        state.lia0 = 'on';
      }
      if (zhi1 == 2) {
        state.lia1 = 'on';
      }
      if (zhi1 == 3) {
        state.lia2 = 'on';
      }
      if (zhi1 == 4) {
        state.lia3 = 'on';
      }
    },
    daohang(state, number) {
      state.ul0 = 'ul1 cl';
      state.ula = '';
      state.ul3 = 'ul1 cl';
      state.ulc = '';
      state.ul2 = 'ul1 cl';
      state.ulb = '';
      state.lib0 = '';
      if (number < 6) {
        state.ul0 = "ul1 on cl";
        state.ula = 'on';
        state.lia0 = '',
          state.lia1 = '',
          state.lia2 = '',
          state.lia3 = '';
        state.lia4 = '';
        if (number == 1) {
          state.lia0 = 'on';
        }
        if (number == 2) {
          state.lia1 = 'on';
        }
        if (number == 3) {
          state.lia2 = 'on';
        }
        if (number == 4) {
          state.lia3 = 'on';
        }
        if (number == 5) {
          state.lia4 = 'on';
        }
      }
      if (number == 13) {
        state.ul3 = "ul1 on cl";
        state.ulc = 'on';
      }
    },
    daohangx(state, number) {
      state.ul0 = 'ul1 cl',
        state.ula = '',
        state.ul3 = 'ul1 cl',
        state.ulc = '';
      state.ul2 = 'ul1 cl',
        state.ulb = '';
      if (number == 0) {
        state.ul2 = "ul1 on cl"
        state.ulb = 'on'
      }
    },
    collectlist(state, jsonx) {
      state.filelist = [];
      state.cunbchu = [];
      const timestamp = new Date().getTime();
      const moduleid = "3401";
      const username = localStorage.getItem("loginname");
      jsonx = JSON.parse(jsonx);
      const params = {
        "loginname": username,
        "starttime": jsonx.startdate,
        "endtime": jsonx.enddate,
        "orderby": jsonx.orderby,
        "filename": jsonx.keyword,
        "page": state.curpage - 1,
        "pagesize": state.pagesize
      };
      console.log("params=" + JSON.stringify(params));
      const jmparams = Encrypt(params);
      const sign = md5(timestamp + moduleid + jmparams);
      axios
        .post(
          helper.webUrl +
          "clientAPI.do?moduleid=" +
          moduleid +
          "&timestamp=" +
          timestamp +
          "&params=" +
          jmparams +
          "&sign=" +
          sign,
          {}
        )
        .then(function (res) {
          if (res.status == 200) {
            const dda = res.data;
            const datas = Decrypt(dda);
            const datan = JSON.parse(datas);
            if (datan.result == "1") {
              state.pages = datan.totalpage;//总页码
              state.totaltiao = datan.total;//总记录
              const pagels = [];
              for (let i = 1; i < state.pages + 1; i++) {
                pagels.push(i);
              }
              state.yema = pagels;
              for (let i = 0; i < datan.data.length; i++) {
                datan.data[i].checked = false;
                datan.data[i].bianji = '';
              }
              if (datan.data != null) {
                state.filelist = datan.data;
                state.cunbchu = state.filelist;
              }
            }
          }
        })
    },
    loadmsg(state, jsonx) {
      state.filelist = [];
      jsonx = JSON.parse(jsonx);
      const timestamp = new Date().getTime();
      const moduleid = "5005";
      const loginname = localStorage.getItem("loginname");
      const params = {
        loginname: loginname,
        mtype: jsonx.mtype,
        state: jsonx.state,
        title: jsonx.keyWord,
        page: state.curpage - 1,
        pagesize: state.pagesize
      };
      const jmparams = Encrypt(params);
      const sign = md5(timestamp + moduleid + jmparams);
      axios
        .post(
          helper.webUrl +
          "clientAPI.do?moduleid=" +
          moduleid +
          "&timestamp=" +
          timestamp +
          "&params=" +
          jmparams +
          "&sign=" +
          sign,
          {}
        )
        .then(function (response) {
          const dda = response.data;
          const datas = Decrypt(dda);
          const datan = JSON.parse(datas);
          if (datan.result == 1) {
            state.pages = datan.totalpage;//总页码
            state.totaltiao = datan.total;//总记录
            const pagels = [];
            for (let i = 1; i < state.pages + 1; i++) {
              pagels.push(i);
            }
            state.yema = pagels;
            //处理权限
            for (let i = 0; i < datan.data.length; i++) {
              datan.data[i].checked = false;
              datan.data[i].bianji = '';
            }
            state.filelist = datan.data.sort(helper.getSortFun("desc", "createdate"));
            state.cunbchu = state.filelist;
          }
        });
    },
    sharelist(state, jsonx) {
      jsonx = JSON.parse(jsonx);
      state.filelist = [];
      state.cunbchu = [];
      const timestamp = new Date().getTime();
      const moduleid = "3304";
      const loginname = localStorage.getItem("loginname");
      const params = {
        "loginname": loginname,
        "starttime": jsonx.startdate,
        "orderby": jsonx.orderby,
        "endtime": jsonx.enddate,
        "title": jsonx.searchvalue,
        "page": state.curpage - 1,
        "pagesize": state.pagesize
      };
      console.log("params=" + JSON.stringify(params));
      const jmparams = Encrypt(params);
      const sign = md5(timestamp + moduleid + jmparams);
      axios
        .post(
          helper.webUrl +
          "clientAPI.do?moduleid=" +
          moduleid +
          "&timestamp=" +
          timestamp +
          "&params=" +
          jmparams +
          "&sign=" +
          sign,
          {}
        )
        .then(function (res) {
          if (res.status == 200) {
            const dda = res.data;
            const datas = Decrypt(dda);
            const datan = JSON.parse(datas);
            if (datan.result == "1") {
              console.log(JSON.stringify(datan));
              state.pages = datan.totalpage;//总页码
              state.totaltiao = datan.total;//总记录
              const pagels = [];
              for (let i = 1; i < state.pages + 1; i++) {
                pagels.push(i);
              }
              state.yema = pagels;
              for (let i = 0; i < datan.data.length; i++) {
                datan.data[i].checked = false;
              }
              state.filelist = datan.data;
              state.cunbchu = datan.data;
            }
          }
        })
    },
    messagelist(state) {
      state.filelist = [];
      state.cunbchu = [];
      state.plist = [];
      const timestamp = new Date().getTime();
      const moduleid = "5002";
      const username = localStorage.getItem("loginname");
      const params = {
        "loginname": username
      };
      const jmparams = Encrypt(params);
      const sign = md5(timestamp + moduleid + jmparams);
      axios
        .post(
          helper.webUrl +
          "clientAPI.do?moduleid=" +
          moduleid +
          "&timestamp=" +
          timestamp +
          "&params=" +
          jmparams +
          "&sign=" +
          sign,
          {}
        )
        .then(function (res) {
          if (res.status == 200) {
            const dda = res.data;
            const datas = Decrypt(dda);
            const datan = JSON.parse(datas);
            if (datan.result == "1") {
              for (let i = 0; i < datan.data.length; i++) {
                datan.data[i].checked = false;
              }
              state.filelist = datan.data;
              state.cunbchu = datan.data;
              if (state.filelist != null) {
                state.totaltiao = state.filelist.length;
                if ((state.filelist.length > state.pagesize) && (state.filelist.length % state.pagesize > 0)) {
                  state.pages = Math.ceil(state.filelist.length / state.pagesize);
                }
                else {
                  state.pages = Math.ceil(state.filelist.length / state.pagesize);
                }
                state.plist = state.filelist.slice((state.curpage - 1) * state.pagesize, state.curpage * state.pagesize);
                const pagels = [];
                const zhi = Math.ceil(state.filelist.length / state.pagesize);
                for (let i = 0; i < zhi; i++) {
                  pagels.push(i);
                }
                state.yema = pagels;
              }
            }
          }
        })
    },
    rizhilist(state, jsonx) {
      const jsony = JSON.parse(jsonx);
      state.filelist = [];
      state.cunbchu = [];
      state.plist = [];
      const timestamp = new Date().getTime();
      const moduleid = "2013";
      const username = localStorage.getItem("loginname");
      const params = {
        "loginname": username,
        "orderby": jsony.orderby,
        "createdate": jsony.createdate,
        "descript": jsony.searchvalue,
        "page": state.curpage,
        "pagesize": state.pagesize
      };
      const jmparams = Encrypt(params);
      const sign = md5(timestamp + moduleid + jmparams);
      axios
        .post(
          helper.webUrl +
          "clientAPI.do?moduleid=" +
          moduleid +
          "&timestamp=" +
          timestamp +
          "&params=" +
          jmparams +
          "&sign=" +
          sign,
          {}
        )
        .then(function (res) {
          if (res.status == 200) {
            const dda = res.data;
            const datas = Decrypt(dda);
            const datan = JSON.parse(datas);
            if (datan.result == "1") {
              state.pages = datan.totalpage;//总页码
              state.totaltiao = datan.total;//总记录
              const pagels = [];
              for (let i = 1; i < state.pages + 1; i++) {
                pagels.push(i);
              }
              state.yema = pagels;
              for (let i = 0; i < datan.data.length; i++) {
                datan.data[i].checked = false;
              }
              if (state.filelist != null) {
                state.filelist = datan.data.sort(helper.getSortFun("desc", "Logid"));
                state.plist = state.filelist;
                state.cunbchu = state.filelist;
              }
            }
          }
        })
    },
    duqugerenlist(state, jsonx) {
      state.filelist = [];
      state.cunbchu = [];
      state.plist = [];
      const timestamp = new Date().getTime();
      const moduleid = "3014";
      const username = localStorage.getItem("loginname");
      jsonx = JSON.parse(jsonx);
      const params = {
        "loginname": username,
        "diskid": '',
        "folderid": '',
        "filetype": state.filetype,
        "state": "1",
        "keyword": jsonx.keyword,
        "orderby": jsonx.orderby,
        "page": state.curpage - 1,
        "pagesize": state.pagesize
      };
      const jmparams = Encrypt(params);
      const sign = md5(timestamp + moduleid + jmparams);
      axios
        .post(
          helper.webUrl +
          "clientAPI.do?moduleid=" +
          moduleid +
          "&timestamp=" +
          timestamp +
          "&params=" +
          jmparams +
          "&sign=" +
          sign,
          {}
        )
        .then(function (res) {
          if (res.status == 200) {
            const dda = res.data;
            const datas = Decrypt(dda);
            const datan = JSON.parse(datas);
            if (datan.result == "1") {
              state.pages = datan.totalpage;//总页码
              state.totaltiao = datan.total;//总记录
              const pagels = [];
              for (let i = 1; i < state.pages + 1; i++) {
                pagels.push(i);
              }
              state.yema = pagels;
              for (let i = 0; i < datan.data.length; i++) {
                datan.data[i].icon = helper.webUrl + datan.data[i].icon;
                datan.data[i].checked = false;
                datan.data[i].bianji = '';
                const zhi = datan.data[i].filesize;
                datan.data[i].ysize = parseInt(zhi);
                if (zhi < 1024) {
                  datan.data[i].filesize = zhi + 'B';
                }
                if ((zhi > 1024) && (zhi < 1024 * 1024)) {
                  datan.data[i].filesize = String(Math.ceil(zhi / 1024)) + "KB"
                }
                if ((zhi > 1024 * 1024) && (zhi < 1024 * 1024 * 1024)) {
                  datan.data[i].filesize = String(Math.ceil(zhi / 1024 / 1024)) + "MB"
                }
                if ((zhi > 1024 * 1024 * 1024) && (zhi < 1024 * 1024 * 1024 * 1024)) {
                  datan.data[i].filesize = String(Math.ceil(zhi / 1024 / 1024 / 1024)) + "G"
                }
              }
              state.filelist = datan.data;
              state.cunbchu = datan.data;
              state.plist = datan.data;
            }
          }
        })
    },
    allselect(state, jsonx) {
      state.filelist = [];
      state.cunbchu = [];
      const timestamp = new Date().getTime();
      const moduleid = "3203";
      const username = localStorage.getItem("loginname");
      jsonx = JSON.parse(jsonx);
      const params = {
        "loginname": username,
        "keyword": jsonx.keyword,
        "orderby": jsonx.orderby,
        "filetype": jsonx.filetype,
        "fulltext": jsonx.fulltext,
        "pridisk": jsonx.pridisk,
        "pubdisk": jsonx.pubdisk,
        "startdate": jsonx.startdate,
        "enddate": jsonx.enddate,
        "page": state.curpage - 1,
        "pagesize": state.pagesize
      };
      const jmparams = Encrypt(params);
      const sign = md5(timestamp + moduleid + jmparams);
      axios
        .post(
          helper.webUrl +
          "clientAPI.do?moduleid=" +
          moduleid +
          "&timestamp=" +
          timestamp +
          "&params=" +
          jmparams +
          "&sign=" +
          sign,
          {}
        )
        .then(function (res) {
          if (res.status == 200) {
            const dda = res.data;
            const datas = Decrypt(dda);
            const datan = JSON.parse(datas);
            if (datan.result == "1") {
              state.pages = datan.totalpage;//总页码
              state.totaltiao = datan.total;//总记录
              const pagels = [];
              for (let i = 1; i < state.pages + 1; i++) {
                pagels.push(i);
              }
              state.yema = pagels;
              for (let i = 0; i < datan.data.length; i++) {
                datan.data[i].icon = helper.webUrl + datan.data[i].icon;
                datan.data[i].checked = false;
                datan.data[i].bianji = '';
                const zhi = datan.data[i].filesize;
                datan.data[i].ysize = parseInt(zhi);
                if (zhi < 1024) {
                  datan.data[i].filesize = zhi + 'B';
                }
                if ((zhi > 1024) && (zhi < 1024 * 1024)) {
                  datan.data[i].filesize = String(Math.ceil(zhi / 1024)) + "KB"
                }
                if ((zhi > 1024 * 1024) && (zhi < 1024 * 1024 * 1024)) {
                  datan.data[i].filesize = String(Math.ceil(zhi / 1024 / 1024)) + "MB"
                }
                if ((zhi > 1024 * 1024 * 1024) && (zhi < 1024 * 1024 * 1024 * 1024)) {
                  datan.data[i].filesize = String(Math.ceil(zhi / 1024 / 1024 / 1024)) + "G"
                }
              }
              state.filelist = datan.data;
              state.cunbchu = datan.data;
            }
          }
        })
    },
    duqudoubinlist(state, keyWord) {
      const timestamp = new Date().getTime();
      const moduleid = "3101";
      const username = localStorage.getItem("loginname");
      const params = {
        "title": keyWord,
        "loginname": username,
        "page": state.curpage - 1,
        "pagesize": state.pagesize
      };
      console.log("params=" + JSON.stringify(params))
      const jmparams = Encrypt(params);
      const sign = md5(timestamp + moduleid + jmparams);
      axios
        .post(
          helper.webUrl +
          "clientAPI.do?moduleid=" +
          moduleid +
          "&timestamp=" +
          timestamp +
          "&params=" +
          jmparams +
          "&sign=" +
          sign,
          {}
        )
        .then(function (res) {
          if (res.status == 200) {
            const dda = res.data;
            const datas = Decrypt(dda);
            const datan = JSON.parse(datas);
            if (datan.result == "1") {
              state.pages = datan.totalpage;//总页码
              state.totaltiao = datan.total;//总记录
              const pagels = [];
              for (let i = 1; i < state.pages + 1; i++) {
                pagels.push(i);
              }
              state.yema = pagels;
              for (let i = 0; i < datan.data.length; i++) {
                datan.data[i].icon = helper.webUrl + datan.data[i].icon;
                datan.data[i].checked = false;
              }
              datan.data.sort(helper.getSortFun("desc", "createdate"));
              state.plist = datan.data;
            }
          }
        })

    },
    selecttype(state, typeid) {
      if (typeid != 0) {
        state.filelist = state.cunbchu.filter(function (item) {
          return item.filetype == typeid;
        });
      } else {
        state.filelist = state.cunbchu;
      }
    },
    getpanduqu(state) {
      const timestamp = new Date().getTime();
      const moduleid = "2002";
      const username = localStorage.getItem("loginname");
      const params = { "loginname": username };
      const jmparams = Encrypt(params);
      const sign = md5(timestamp + moduleid + jmparams);
      axios
        .post(
          helper.webUrl +
          "clientAPI.do?moduleid=" +
          moduleid +
          "&timestamp=" +
          timestamp +
          "&params=" +
          jmparams +
          "&sign=" +
          sign,
          {}
        )
        .then(function (res) {
          if (res.status == 200) {
            const dda = res.data;
            const datas = Decrypt(dda);
            const datan = JSON.parse(datas);
            if (datan.result == "1") {
              datan.data.sort(helper.getSortFun('asc', 'letter'));
              state.pan = datan.data;
              localStorage.setItem('pan', JSON.stringify(datan.data));
            }
          }
        })

    },
    foldernamepx(state, jsonx) {
      jsonx = JSON.parse(jsonx);
      state.filelist.sort(helper.getSortFun(jsonx.asc, jsonx.filename));
    },
    getpan(state) {
      state.pan = JSON.parse(localStorage.getItem('pan'));
    },
    huancun(state, jsonx) {
      const datas = localStorage.getItem("pan");
      const datanx = JSON.parse(datas);
      jsonx = JSON.parse(jsonx);
      datanx.sort(helper.getSortFun(jsonx.desc, jsonx.orderziduan));
      const news1 = datanx.filter(function (item) {
        if (jsonx.typeid != "") {
          return ((item.parentid == jsonx.typeid) && (item.parentid != 0))
        }
      });
      state.Gdisklist = news1;
      const news3 = datanx.filter(function (item) {
        return ((item.parentid == jsonx.parentid) && (item.letter == jsonx.letter) && (item.typeid == jsonx.typeid));
      });
      if (news3.length > 0) {
        if ((news3[0] != null) && (news3[0].disks != undefined)) {
          if (news3[0].disks.length > 0) {
            news3[0].disks.sort(helper.getSortFun(jsonx.desc, jsonx.orderziduan));
            state.curdiskid = news3[0].disks[0].diskid;
            localStorage.setItem("disksize", news3[0].disks[0].disksize);
            localStorage.setItem("usersize", news3[0].disks[0].usersize);
          } else {
            state.curdiskid = 0;
          }

          state.GGdisklist = news3[0].disks;
        }
      }
      else {
        state.curdiskid = 0;
      }
    },
    duqugeren(state, jsonx) { //通过接口读取文件夹和文件,个人文档keyword, orderby, page, pagesize
      const timestamp = new Date().getTime();
      const moduleid = "3201";
      const username = localStorage.getItem("loginname");
      jsonx = JSON.parse(jsonx);
      const params = {
        "loginname": username,
        "keyword": jsonx.keyword,
        "orderby": jsonx.orderby,
        "page": 0,
        "pagesize": 1000
      };
      const jmparams = Encrypt(params);
      const sign = md5(timestamp + moduleid + jmparams);
      axios
        .post(
          helper.webUrl +
          "clientAPI.do?moduleid=" +
          moduleid +
          "&timestamp=" +
          timestamp +
          "&params=" +
          jmparams +
          "&sign=" +
          sign,
          {}
        )
        .then(function (res) {
          if (res.status == 200) {
            const dda = res.data;
            const datas = Decrypt(dda);
            const datan = JSON.parse(datas);
            if (datan.result == "1") {
              state.pages = datan.totalpage;//总页码
              state.totaltiao = datan.total;//总记录
              const pagels = [];
              for (let i = 1; i < state.pages + 1; i++) {
                pagels.push(i);
              }
              state.yema = pagels;
              const arr = [];
              for (let j = 0; j < datan.data.folderlist.length; j++) {
                //如果字符串中不包含目标字符会返回-1
                if (jsonx.keyword != "") {
                  if (datan.data.folderlist[j].foldername.indexOf(jsonx.keyword) >= 0) {
                    arr.push(datan.data.folderlist[j]);
                  }
                }
                else {
                  arr.push(datan.data.folderlist[j]);
                }
              }

              datan.data.folderlist = arr;
              for (let i = 0; i < datan.data.folderlist.length; i++) {
                datan.data.folderlist[i].checked = false;
                datan.data.folderlist[i].bianji = '';
              }
              state.folderlist = datan.data.folderlist;
              //做排序
              for (let i = 0; i < datan.data.filelist.length; i++) {
                datan.data.filelist[i].icon = helper.webUrl + datan.data.filelist[i].icon;
                datan.data.filelist[i].checked = false;
                datan.data.filelist[i].bianji = '';
                const zhi = datan.data.filelist[i].filesize;
                datan.data.filelist[i].ysize = parseInt(zhi);
                if (zhi < 1024) {
                  datan.data.filelist[i].filesize = zhi + 'B';
                }
                if ((zhi > 1024) && (zhi < 1024 * 1024)) {
                  datan.data.filelist[i].filesize = String(Math.ceil(zhi / 1024)) + "KB"
                }
                if ((zhi > 1024 * 1024) && (zhi < 1024 * 1024 * 1024)) {
                  datan.data.filelist[i].filesize = String(Math.ceil(zhi / 1024 / 1024)) + "MB"
                }
                if ((zhi > 1024 * 1024 * 1024) && (zhi < 1024 * 1024 * 1024 * 1024)) {
                  datan.data.filelist[i].filesize = String(Math.ceil(zhi / 1024 / 1024 / 1024)) + "G"
                }
              }
              if (datan.data.filelist.length > 0) {
                if ((jsonx.orderasc != "") && (jsonx.orderasc != undefined) && (jsonx.orderby != "")) {
                  datan.data.filelist = datan.data.filelist.sort(helper.getSortFun(jsonx.orderasc, jsonx.orderby));
                }
              }
              state.filelist = datan.data.filelist;
              state.cunbchu = datan.data.filelist;
            }
          }
        })

    },

    foledfun(state, jsonx) {//读取curdiskid,curfolderid
      const moduleid = "4006";
      const timestamp = (new Date()).getTime();
      jsonx = JSON.parse(jsonx);
      const params = {
        "diskid": jsonx.curdiskid,
        "parentid": jsonx.curfolderid
      };
      const jmparams = Encrypt(params);
      const sign = md5(timestamp + moduleid + jmparams);
      axios
        .post(
          helper.webUrl +
          "clientAPI.do?moduleid=" +
          moduleid +
          "&timestamp=" +
          timestamp +
          "&params=" +
          jmparams +
          "&sign=" +
          sign,
          {}
        )
        .then(function (res) {
          if (res.status == 200) {
            const dda = res.data;
            const datas = Decrypt(dda);
            const datan = JSON.parse(datas);
            if (datan.result == "1") {
              for (let i = 0; i < datan.data.length; i++) {
                datan.data[i].checked = false;
                datan.data[i].bianji = '';
              }
              const len = datan.data.length;
              const arr = [];
              for (let j = 0; j < len; j++) {
                //如果字符串中不包含目标字符会返回-1
                if (jsonx.keyword != "") {
                  if (datan.data[j].foldername.indexOf(jsonx.keyword) >= 0) {
                    arr.push(datan.data[j]);
                  }
                }
                else {
                  arr.push(datan.data[j]);
                }
              }
              state.folderlist = arr;
            }
          }
        })
    },
    duqu(state, jsonx) {
      const timestamp = (new Date()).getTime();
      const moduleid = "3013";
      jsonx = JSON.parse(jsonx);
      const params = {
        "diskid": jsonx.curdiskid,
        "folderid": jsonx.curfolderid,
        "filetype": jsonx.filetype,
        "orderby": jsonx.orderby,
        "keyword": jsonx.keyword,
        "page": state.curpage - 1,
        "pagesize": state.pagesize
      };
      const jmparams = Encrypt(params);
      const sign = md5(timestamp + moduleid + jmparams);
      axios
        .post(
          helper.webUrl +
          "clientAPI.do?moduleid=" +
          moduleid +
          "&timestamp=" +
          timestamp +
          "&params=" +
          jmparams +
          "&sign=" +
          sign,
          {}
        )
        .then(function (res) {
          if (res.status == 200) {
            const dda = res.data;
            const datas = Decrypt(dda);
            const datan = JSON.parse(datas);
            if (datan.result == "1") {
              state.pages = datan.totalpage;//总页码
              state.totaltiao = datan.total;//总记录
              const pagels = [];
              for (let i = 1; i < state.pages + 1; i++) {
                pagels.push(i);
              }
              state.yema = pagels;
              for (let i = 0; i < datan.data.length; i++) {
                datan.data[i].icon = helper.webUrl + datan.data[i].icon;
                datan.data[i].checked = false;
                datan.data[i].bianji = '';
                const zhi = datan.data[i].filesize;
                datan.data[i].ysize = parseInt(zhi);
                if (zhi < 1024) {
                  datan.data[i].filesize = zhi + 'B';
                }
                if ((zhi > 1024) && (zhi < 1024 * 1024)) {
                  datan.data[i].filesize = String(Math.ceil(zhi / 1024)) + "KB"
                }
                if ((zhi > 1024 * 1024) && (zhi < 1024 * 1024 * 1024)) {
                  datan.data[i].filesize = String(Math.ceil(zhi / 1024 / 1024)) + "MB"
                }
                if ((zhi > 1024 * 1024 * 1024) && (zhi < 1024 * 1024 * 1024 * 1024)) {
                  datan.data[i].filesize = String(Math.ceil(zhi / 1024 / 1024 / 1024)) + "G"
                }
              }
              state.filelist = datan.data;
              state.cunbchu = datan.data;
            }
          }
        })
    },

    duqux(state, jsonx) {
      const timestamp = (new Date()).getTime();
      const moduleid = "3013";
      jsonx = JSON.parse(jsonx);
      const params = {
        "diskid": jsonx.curdiskid,
        "folderid": jsonx.curfolderid,
        "filetype": jsonx.filetype,
        "orderby": jsonx.orderby,
        "keyword": jsonx.keyword,
        "page": 0,
        "pagesize": 1000
      };
      const jmparams = Encrypt(params);
      const sign = md5(timestamp + moduleid + jmparams);
      axios
        .post(
          helper.webUrl +
          "clientAPI.do?moduleid=" +
          moduleid +
          "&timestamp=" +
          timestamp +
          "&params=" +
          jmparams +
          "&sign=" +
          sign,
          {}
        )
        .then(function (res) {
          if (res.status == 200) {
            const dda = res.data;
            const datas = Decrypt(dda);
            const datan = JSON.parse(datas);
            if (datan.result == "1") {
              state.pages = datan.totalpage;//总页码
              state.totaltiao = datan.total;//总记录
              const pagels = [];
              for (let i = 1; i < state.pages + 1; i++) {
                pagels.push(i);
              }
              state.yema = pagels;
              for (let i = 0; i < datan.data.length; i++) {
                datan.data[i].icon = helper.webUrl + datan.data[i].icon;
                datan.data[i].checked = false;
                datan.data[i].bianji = '';
                const zhi = datan.data[i].filesize;
                datan.data[i].ysize = parseInt(zhi);
                if (zhi < 1024) {
                  datan.data[i].filesize = zhi + 'B';
                }
                if ((zhi > 1024) && (zhi < 1024 * 1024)) {
                  datan.data[i].filesize = String(Math.ceil(zhi / 1024)) + "KB"
                }
                if ((zhi > 1024 * 1024) && (zhi < 1024 * 1024 * 1024)) {
                  datan.data[i].filesize = String(Math.ceil(zhi / 1024 / 1024)) + "MB"
                }
                if ((zhi > 1024 * 1024 * 1024) && (zhi < 1024 * 1024 * 1024 * 1024)) {
                  datan.data[i].filesize = String(Math.ceil(zhi / 1024 / 1024 / 1024)) + "G"
                }
              }
              state.filelist = datan.data;
              state.cunbchu = datan.data;
            }
          }
        })
    }
  },
  actions: {
    asyncSetClassa(store, params) {
      setTimeout(() => {
        store.commit('setClassa', params);
      }, 500);

    },
    asyncSetClassb(store, params) {
      setTimeout(() => {
        store.commit('setClassb', params);
      }, 500);
    }
  },
  modules: {
  }
})
